module.exports = __webpack_public_path__ + "static/media/1POLICY49.525ba2f9.jpg";